module.exports = __webpack_public_path__ + "static/media/Space Fan.950f7520.jpg";